"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alano-di-piave": {
    "bcf95d6b": [{
      "hkey": "6f4e0ff0",
      "slug": "alano-di-piave",
      "name": "Alano di Piave",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "6f4e0ff0",
      "slug": "alano-di-piave",
      "name": "Alano di Piave",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ba0f8f7b": [{
      "hkey": "226234a8",
      "slug": "setteville",
      "name": "Setteville",
      "primary": true,
      "skipSearch": false
    }],
    "alano-di-piave": [{
      "hkey": "226234a8",
      "slug": "setteville",
      "name": "Setteville",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;